import React, { useState, useEffect, useMemo } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { getMonthName } from "../General/Utility";

/** Supports PascalCase (default API) and camelCase JSON for balances. */
function rowBalance(item) {
  if (item == null) return 0;
  const v =
    item.Current_Balance ??
    item.currentBalance ??
    item.current_balance ??
    0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

const UnpaidStudentPrint = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [ReportMonth, setReportMonth] = useState("");
  const [ReportYear, setReportYear] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const titleFromUrl = useMemo(() => {
    const q = new URLSearchParams(
      typeof window !== "undefined" ? window.location.search : ""
    );
    const y = q.get("ReportYear") || "";
    const m = q.get("ReportMonth") || "";
    const mi = parseInt(String(m).trim(), 10);
    const monthLabel =
      Number.isFinite(mi) && mi >= 1 && mi <= 12 ? getMonthName(mi) : m || "—";
    return `List of defaulter students (unpaid challans) for ${monthLabel} ${y}`.trim();
  }, []);

  useEffect(() => {
    document.title = "Unpaid Student Print";

    setLoading(true);
    const urlParams = new URLSearchParams(window.location.search);

    const reportYearRaw = urlParams.get("ReportYear");
    const reportMonthRaw = urlParams.get("ReportMonth");
    const sessionRaw =
      urlParams.get("Session_Id") ??
      urlParams.get("SessionID") ??
      urlParams.get("Session") ??
      "";
    const wingRaw =
      urlParams.get("Wing_Id") ?? urlParams.get("Wing") ?? "";
    const classRaw =
      urlParams.get("Class_Id") ?? urlParams.get("Class") ?? "";
    const sectionRaw =
      urlParams.get("Section_Id") ?? urlParams.get("Section") ?? "";
    const orderByRaw = urlParams.get("OrderBy") ?? "";

    setReportYear(reportYearRaw || "");
    setReportMonth(reportMonthRaw || "");

    const ry = parseInt(String(reportYearRaw ?? "").trim(), 10);
    const rm = parseInt(String(reportMonthRaw ?? "").trim(), 10);
    const sess = parseInt(String(sessionRaw).trim(), 10);
    const w = parseInt(String(wingRaw).trim(), 10);
    const c = parseInt(String(classRaw).trim(), 10);
    const s = parseInt(String(sectionRaw).trim(), 10);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: 1,
      pageSize: 10000,
      ReportYear: Number.isFinite(ry) ? ry : 0,
      ReportMonth: Number.isFinite(rm) ? rm : 0,
      SessionID: Number.isFinite(sess) && sess > 0 ? sess : 0,
      Wing_Id: Number.isFinite(w) ? w : 0,
      Class_Id: Number.isFinite(c) ? c : 0,
      Section_Id: Number.isFinite(s) ? s : 0,
      OrderBy: orderByRaw || "Student_Name",
    };

    var api_config = {
      method: "post",
      url: config.base_url + "/Reports/GetUnpaidStudents",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        const rows = response.data.ListofRecords || [];
        setLedger(rows);
        setTotalRecords(response.data.totalRecords ?? rows.length);
        setLoading(false);
      })
      .catch(function () {
        setLedger([]);
        setTotalRecords(0);
        setLoading(false);
      });
  }, []);

  const footerTotal = listOfLedger.reduce(
    (s, item) => s + rowBalance(item),
    0
  );

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{item.Registration_No}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Father_Name}</td>
            <td>{item.Contact_Mobile}</td>
            <td>{item.Class_Name}</td>
            <td>{item.Section_Name}</td>
            <td>{rowBalance(item)}</td>
          </tr>
        );
      });
    }
    return (
      <tr>
        <td colSpan="8">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  const headerTitle =
    ReportYear && ReportMonth
      ? (() => {
          const mi = parseInt(String(ReportMonth).trim(), 10);
          if (Number.isFinite(mi) && mi >= 1 && mi <= 12)
            return `List of defaulter students (unpaid challans) for ${getMonthName(
              mi
            )} ${ReportYear}`;
          return titleFromUrl;
        })()
      : titleFromUrl;

  return (
    <>
      <Page orientation="portrait" size="a4">
        <PrintHeader title={headerTitle} />
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <th>Sr #</th>
              <th style={{ width: "75px" }}>Code</th>
              <th style={{ width: "170px" }}>Student&apos;s Name</th>
              <th style={{ width: "170px" }}>Father&apos;s Name</th>
              <th style={{ width: "60px" }}>Contact</th>
              <th>Class Name</th>
              <th>Section Name</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan="8">
                  <Spinner animation="border" role="status"></Spinner>
                </td>
              </tr>
            ) : (
              <>
                {renderLedger()}
                {listOfLedger != null && listOfLedger.length > 0 && (
                  <tr>
                    <th className="text-end" colSpan={8}>
                      Total records: {totalRecords}
                      {" · "}
                      Total amount: {footerTotal.toFixed(0)}
                    </th>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default UnpaidStudentPrint;
